<template>
  <div class="cronus-progress-bar">
    <div class="progress-bar" :style="{'width': progress}"></div>
  </div>
</template>

<script>

  export default {
    name: "cardProgress",
    data() {
      return {
        progress: 0
      }
    },
    mounted() {
      window.onscroll = () => { 
        this.calcWidth()
      }
    },
    methods: {
      calcWidth() {
        const height = document.querySelector('#luandaleaks')
        const totalHeight = document.body.scrollTop || document.documentElement.scrollTop
        this.progress = ((totalHeight / height.clientHeight) * 100) + '%'
      }
    }
  }

</script>